import React from "react"
import { CrossSellingRankingTable } from "../CrossSellingRankingTable"
import useGetRankingInformation from "components/Transactional/CrossSelling/hooks/useGetRankingInformation"
import { RequestHandler } from "components/Shared/RequestHandler"
import InformationTableSkeleton from "components/Shared/InformationTable/Skeleton/InformationTableSkeleton"
import { RequestParameters } from "components/Shared/Filters/interfaces"

type CrossSellingRankingContainerProps = {
	filters: RequestParameters
}

const CrossSellingRankingContainer = (
	props: CrossSellingRankingContainerProps
) => {
	const { filters } = props
	const DEFAULT_DATA = {
		crossSellingRanking: [],
	}
	const {
		data = DEFAULT_DATA,
		isLoading,
		isError,
		error,
		refetch,
	} = useGetRankingInformation(filters)
	return (
		<RequestHandler
			error={error}
			isError={isError}
			isLoading={isLoading}
			skeleton={<InformationTableSkeleton />}
			retry={refetch}
			hasData={data.crossSellingRanking.length > 0}
		>
			<CrossSellingRankingTable data={data.crossSellingRanking} />
		</RequestHandler>
	)
}

export default CrossSellingRankingContainer
